import { render, staticRenderFns } from "./OptimizationSwitcher.vue?vue&type=template&id=69ba29fd&scoped=true&"
import script from "./OptimizationSwitcher.vue?vue&type=script&lang=js&"
export * from "./OptimizationSwitcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ba29fd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VSwitch})
